
import { GET_INVOICES } from 'redux/actions/actions'
import { initialState } from './initialState'

export function invoicesReducer (state = initialState.invoices, action) {
  const { type, payload } = action
  switch (type) {
    case GET_INVOICES:
      return payload
    default:
      return state
  }
}
